import {ICategory} from "../../core/api/dto/Category.g";
import {actionCreator} from "../../core/store/common/actionCreator";

export class CategoryAction {
    public static getRoot = actionCreator.async<IEmpty, ICategory[], Error>("Category/DATA");
    public static add = actionCreator.async<IEmpty, IEmpty, Error>("Category/ADD");
    public static delete = actionCreator.async<IEmpty, IEmpty, Error>("Category/DELETE");
    public static update = actionCreator.async<IEmpty, IEmpty, Error>("Category/UPDATE");
}
